/**
 * @file   src\mobile\components\ProDashboardMenu.js
 * @brief  This file is responsible for post dashboard menu
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import {
  checkTutorialDisplayStatus,
  getCurrentPath,
  getUserId,
  saveTutorialStatusToLocal,
} from "../../helpers/common";
import { dashBoardActivePageList } from "../../constants/common";
import { saveTutorialStatus } from "../../services/commonServices";

const ProDashboardMenu = (props) => {
  const { handleNavigation, agent_dashboard } = props;
  const currentLocation = getCurrentPath();
  const [displayTutorial, setDisplayTutorial] = useState(false);
  const tutorialPage = 10;
  const userId = getUserId();
  useEffect(() => {
    setTimeout(function () {
      let tutorialDisplayStatus = checkTutorialDisplayStatus(tutorialPage);
      setDisplayTutorial(tutorialDisplayStatus);
    }, 300);
  }, []);

  //Tutorial status call back
  const handleDisplayTutorial = () => {
    setDisplayTutorial(false);
    saveTutorialStatusToLocal(tutorialPage);
    if (userId) {
      saveTutorialStatus(tutorialPage, 1); //Save status
    }
  };

  return (
    <a
      href={void 0}
      role="button"
      onClick={() => {
        handleNavigation(agent_dashboard);
        if (displayTutorial) {
          handleDisplayTutorial();
        }
      }}
      className={
        _.includes(dashBoardActivePageList, currentLocation)
          ? "text-center select"
          : "text-center"
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M20.25 5.25H16.5V4.5C16.5 3.90326 16.2629 3.33097 15.841 2.90901C15.419 2.48705 14.8467 2.25 14.25 2.25H9.75C9.15326 2.25 8.58097 2.48705 8.15901 2.90901C7.73705 3.33097 7.5 3.90326 7.5 4.5V5.25H3.75C3.35218 5.25 2.97064 5.40804 2.68934 5.68934C2.40804 5.97064 2.25 6.35218 2.25 6.75V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H20.25C20.6478 20.25 21.0294 20.092 21.3107 19.8107C21.592 19.5294 21.75 19.1478 21.75 18.75V6.75C21.75 6.35218 21.592 5.97064 21.3107 5.68934C21.0294 5.40804 20.6478 5.25 20.25 5.25ZM9 4.5C9 4.30109 9.07902 4.11032 9.21967 3.96967C9.36032 3.82902 9.55109 3.75 9.75 3.75H14.25C14.4489 3.75 14.6397 3.82902 14.7803 3.96967C14.921 4.11032 15 4.30109 15 4.5V5.25H9V4.5ZM20.25 6.75V10.6509C17.7185 12.0289 14.8822 12.7505 12 12.75C9.11794 12.7505 6.28165 12.0292 3.75 10.6519V6.75H20.25ZM20.25 18.75H3.75V12.3412C6.31868 13.5977 9.1405 14.2506 12 14.25C14.8596 14.2501 17.6813 13.5969 20.25 12.3403V18.75ZM9.75 10.5C9.75 10.3011 9.82902 10.1103 9.96967 9.96967C10.1103 9.82902 10.3011 9.75 10.5 9.75H13.5C13.6989 9.75 13.8897 9.82902 14.0303 9.96967C14.171 10.1103 14.25 10.3011 14.25 10.5C14.25 10.6989 14.171 10.8897 14.0303 11.0303C13.8897 11.171 13.6989 11.25 13.5 11.25H10.5C10.3011 11.25 10.1103 11.171 9.96967 11.0303C9.82902 10.8897 9.75 10.6989 9.75 10.5Z"
          fill="#234D93"
        />
      </svg>
      <span className="position-relative">
        Dashboard
        {displayTutorial && <div className="pro-dashboard-count"></div>}
      </span>
    </a>
  );
};

export default ProDashboardMenu;
